export default __webpack_public_path__ + "static/media/man-vector.825d75a8.png";